import React from 'react';
import { Breadcrumb } from 'antd';
import type { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';
import { useResponsiveSizes } from '../../hooks/use-responsive-sizes';
import type { BreadcrumbConfig, RoutedFormData } from '../../types/templates';

interface DynamicBreadcrumbsProps {
  formData: RoutedFormData;
  config: BreadcrumbConfig;
  separator?: React.ReactNode;
}

export const DynamicBreadcrumbs: React.FC<DynamicBreadcrumbsProps> = ({ formData, config, separator }) => {
  const { fontSize } = useResponsiveSizes();

  const breadcrumbItems = React.useMemo((): BreadcrumbItemType[] => {
    return config.fields
      .filter(field => {
        const value = formData[field];
        if (value === undefined || value === null || value === '') return false;
        if (value === 'no' || value === false) return false;
        return true;
      })
      .map(field => {
        const value = String(formData[field]);
        const formatter = config.formatters?.[field];
        const displayValue = formatter ? formatter(value) : value;
        return { title: `${displayValue}` };
      });
  }, [formData, config]);

  if (breadcrumbItems.length === 0) return null;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Breadcrumb
        items={breadcrumbItems}
        separator={separator}
        style={{
          fontSize: fontSize.base,
          fontWeight: 500,
          cursor: 'default'
        }}
      />
    </div>
  );
};
